var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-container"},[_c('div',{class:{'ttlcentr':_vm.ttlcentr}},[_c('h2',{staticClass:"ttl",style:({ color: _vm.ttlcolor})},[_vm._t("ttl")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }